<template>
    <div>
        <div>
            <vue-headful :title="$t('title_challenges')" description="title" />
        </div>
        <InitialChallengeScreen
            :title="$t('challenge.initial_challenge_title')"
            :text="$t('challenge.initial_text_you_will_get')"
            points="20"
            beecoins="20"
            :loaded="loaded"
            v-if="challengeStage === 'initChallenge'"
        />
        <BeginningInitialChallengeScreen
            :title="$t('challenge.beginning_initial_challenge_title')"
            :text="$t('challenge.beginning_initial_challenge_set_question_option')"
            points="20"
            beecoins="20"
            :getChallenge="getChallenge"
            v-if="challengeStage === 'beginningInitChallenge'"
        />
        <PrizeBreakdown
            :dialog="loaded"
            v-if="challengeStage === 'prizeBreakdown'"
        />
        <MainContainer
            v-if="challengeStage === 'runChallenge'"
        />
    </div>
</template>
<script>
import { mapState, mapActions } from 'vuex'
import * as Sentry from '@sentry/vue'

import challengeService from '@/services/challenge'
import ChallengeConfigService from '@/services/challengeConfig'
import InitialChallengeScreen from '@/components/challenge/InitialChallengeScreen.vue'
import BeginningInitialChallengeScreen from '@/components/challenge/beginningStudents/BeginningInitialChallengeScreen.vue'
import PrizeBreakdown from '@/components/challenge/PrizeBreakdown.vue'
import MainContainer from '@/components/challenge/content/MainContainer.vue'
import {backend_responses, valid_sources_for_challenges} from "../../constants/DefaultConstants";
import initialReaderValidation from "../../mixins/InitialReaderValidation";

export default {
    props: {
        challenge_id: {type: [Number, String], default: 0}
        },
    computed: {
        ...mapState({
            challengeStage: (state) => state.challenge.challengeStage,
            user_id: (state) => state.userData.user.id,
            course: (state) => state.userData.user.course,
        }),
    },
    components: {
        InitialChallengeScreen,
        MainContainer,
        PrizeBreakdown,
        BeginningInitialChallengeScreen
    },
    data() {
        return { loaded: false }
    },
    methods: {
        ...mapActions('challenge', [
            'setQuestions',
            'setEvaluationId',
            'setTestId',
            'setControlsTexts',
            'setTextName',
            'setTestNuncaAplicado',
            'setChallengeStage',
            'setConfig',
            'setChallengeCategories',
            "setTestLevel",
            'setTesterActive'
        ]),
        initChallengeByUserId(id, questionTemplate ) {
            return new Promise((resolve) => {
                challengeService
                    .initTest(id, false,this.isInitialReader, questionTemplate)
                    .then((response) => {
                        resolve({
                            ok: true,
                            data: response,
                        })
                    })
                    .catch((err) => {
                        Sentry.captureException(err);
                        resolve({
                            ok: false,
                            error: err,
                            massage: err.message
                        });
                    })
            })
        },
        getChallengeById(userId, testId, withClones = true) {
            return new Promise((resolve) => {
                challengeService
                    .findTestById(userId, testId, withClones)
                    .then((response) => {
                        resolve({
                            ok: backend_responses[response.status.code] === 'OK',
                            data: response,
                        })
                    })
                    .catch((err) => {
                        Sentry.captureException(err);
                        resolve({
                            ok: false,
                            error: err,
                            massage: err.message
                        });
                    })
            })
        },
        validateAccess(){
            const source = this.$route.query.source;
            if(this.challenge_id && !valid_sources_for_challenges.some(src => source === src)){
                this.$router.push('../home')
            }
        },
        validateChallenge(okResponse = false, testConfig = null, test = null){
            return okResponse && testConfig && test
        },
        async getChallenge( questionTemplate = 1 ) {
            try {
                const {data: { content: {mdTestDTO, mdEvaluacionId, testNuncaAplicado } }, ok} = this.challenge_id ?
                    await this.getChallengeById(this.user_id, this.challenge_id) :
                    await this.initChallengeByUserId(this.user_id, questionTemplate);
                const challengeConfig = await ChallengeConfigService.getConfigByUser(this.user_id)
                const nextStepScreen = this.isInitialReader ? 'prizeBreakdown' : 'initChallenge';
                if (this.validateChallenge(ok, challengeConfig, mdTestDTO)) {
                    this.setConfig(challengeConfig.content);
                    this.setQuestions(mdTestDTO.mdTestPreguntases);
                    this.setEvaluationId(mdEvaluacionId);
                    this.setTestId(mdTestDTO.id);
                    this.setTestNuncaAplicado(testNuncaAplicado);
                    this.setControlsTexts(mdTestDTO.mdTextosdecontrols);
                    this.setTextName(mdTestDTO.nombre);
                    this.setChallengeStage(this.challenge_id ? 'runChallenge' : nextStepScreen);
                    this.setChallengeCategories(mdTestDTO.categories);
                    this.setTesterActive(!!this.challenge_id);
                    this.setTestLevel(mdTestDTO.level);
                    this.loaded = true;
                    return true;
                } else {
                    this.$modal.show({
                        modalType: 'error',
                        title: this.$t('msg_load_error'),
                        text: this.challenge_id ? this.$t(service.data.content)
                            : this.$t('txt_load_error')
                    });
                    return false;
                }
            } catch (err) {
                this.$modal.loadError();
                Sentry.captureException(err);
                return false;
            }
        }
    },
    async created() {

        this.validateAccess();
        if (this.isInitialReader) {
            this.setChallengeStage('beginningInitChallenge');
            return;
        }
        this.setChallengeStage('initChallenge');
        await this.getChallenge();



    },
    mounted() {
        if(process.env.VUE_APP_ENV === 'production') window.ChurnZero.push(['trackEvent', 'challenge', 'Go to Challenge']);
    },
    mixins: [initialReaderValidation]
}
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Open+Sans&family=Patua+One&display=swap');

.initial-display {
    display: none;
}

.row-card {
    height: 50vh;
}

.card-number {
    align-items: center;
    position: relative;
    right: 6vh;
    bottom: 6vh;
}

.title-content {
    text-align: initial;
    margin-top: 5%;
    margin-bottom: 5%;
    font-size: 2vw;
    color: #514773;
    font-family: 'Patua One' !important;
}

.text-content {
    text-align: initial;
    margin-bottom: 1%;
    font-size: 1.2vw;
    color: #514773;
    font-family: 'Open Sans';
}

.container-text {
    width: 20vw;
}

.button-next-1-text {
    color: white;
    font-size: 1vw;
    margin-bottom: 0;
    font-family: 'Open Sans';
}

.number-icon-card {
    color: #ff6f3a;
    font-size: 3vw;
}

.row-right-icon {
    height: 25vh;
}

@media (max-width: 1264px) {
    .row-card {
        height: 70vh;
    }

    .row-right-icon {
        height: 35vh;
    }

    .title-content {
        text-align: initial;
        margin-top: 5%;
        margin-bottom: 5%;
        font-size: 6vw;
        color: #514773;
        font-family: 'Patua One' !important;
    }

    .container-text {
        width: 50vw;
    }

    .text-content {
        text-align: initial;
        margin-bottom: 50px;
        font-size: 4vw;
        color: #514773;
        font-family: 'Open Sans';
    }

    .button-next-1-text {
        color: white;
        font-size: 4vw;
        margin-bottom: 0;
        font-family: 'Open Sans';
    }
}
</style>
